const labelsCategory = {
  1: 'Kurse für Kleinboote (Jolle, Kat, Kielboot)',
  2: 'Kurse Yachtsegeln',
  3: 'Kurse für Bootsführerscheine (SBF, SKS, SSS, SHS)',
  5: 'Spezialseminare (z.B. AstroNav, Sicherheitstraining)',
  6: 'Funkkurse',
  7: 'Ausbildungstörns',
  8: 'Reisetörns',
  90: 'Schuklassen-Programm',
  91: 'TeamBuilding / Events',
  92: 'Angebote für Gruppen'
}

const linksCategory = {
  90: '/segelkurse/angebote-fuer-schulklassen/',
  91: '/segelkurse/angebote-fuer-teambuidlingevents/',
  92: '/segelkurse/angebote-fuer-gruppen-vereine/'
}

const labelsSchool = {
  1: 'Hanseatische Yachtschule Glücksburg',
  2: 'Chiemsee Yachtschule',
  3: 'Theorie-Zweigstelle Hamburg',
  4: 'Theorie-Zweigstelle Ostwestfalen-Lippe',
  5: 'Theorie-Zweigstelle Braunschweig',
  6: 'Theorie-Zweigstelle Hannover',
  7: 'Theorie-Zweigstelle Ruhrgebiet',
  8: 'Theorie-Zweigstelle Mannheim',
  9: 'Theorie-Zweigstelle Nürnberg',
  10: 'Theorie-Zweigstelle Stuttgart',
  11: 'Theorie-Zweigstelle München',
  12: 'Theorie-Zweigstelle Wien',
  13: 'Theorie-Zweigstelle Bonn'
}

const labelsLevel = {
  1: 'Einsteiger',
  2: 'Fortgeschrittene'
}

const labelsLicense = {
  1: 'SBF See',
  2: 'SBF Binnen',
  3: 'SKS',
  4: 'SSS',
  5: 'SHS'
}

const filterLevel = [ '1', '2' ]

const pickerLang = {
  months: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  from: 'Von',
  to: 'Bis'
}

const labelsSchoolAddOn = {
  1: 'Durchgehender Kurs wahlweise mit/ohne Beherbergung u. Vollpension in der Yachtschule',
  2: 'Durchgehender Kurs wahlweise mit/ohne Beherbergung u. Vollpension in der Yachtschule',
  3: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort',
  4: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort',
  5: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort',
  6: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort',
  7: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort',
  8: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort',
  9: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort',
  10: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort',
  11: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort',
  12: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort',
  13: 'Kategorie: Abend- / Tages- oder Wochenendkurse vor Ort'
}

export { labelsCategory, linksCategory, labelsSchool, labelsLevel, labelsLicense, filterLevel, pickerLang, labelsSchoolAddOn }
